import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=658565d9"
import script from "./ItemCreate.vue?vue&type=script&lang=js"
export * from "./ItemCreate.vue?vue&type=script&lang=js"
import style0 from "./ItemCreate.vue?vue&type=style&index=0&id=658565d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports